/* eslint-disable react/no-array-index-key */

import { memo } from 'react';
import styled from 'styled-components';
import { MenuItemElementViewModelDiscriminator, type ProductListMenuItemViewModel } from 'autogen/swagger/all';
import Menu from 'components/generic/menu';
import ListItem from 'components/List/components/ListItem/ListItem';
import { BrandSpecificMenuItemStyling } from '../shared/styles';
import AccordionMenuItem from './AccordionMenuItem';

/* #region styles */
const StyledDefaultMenuSection = styled(Menu.SecondarySection)<{ $level: number }>`
    margin-left: ${({ $level }) => `${$level * 12}px`};
    background-color: transparent;
    padding: 0;
    &:after {
        width: 100%;
    }

    &:empty {
        display: none;
    }
`;

const StyledMenuItemAnchor = styled(ListItem.Action)<{ selected: boolean }>`
    ${BrandSpecificMenuItemStyling}
`;
/* #endregion */

const ItemsRenderer = ({
    menuItems,
    headline,
    level
}: {
    menuItems: ProductListMenuItemViewModel[];
    headline?: string;
    level: number;
}) => (
    <StyledDefaultMenuSection headline={headline} $level={level}>
        {menuItems.map((item, index) => {
            if (item.children.length) {
                return <AccordionMenuItem key={index} item={item} />;
            }

            return MenuItemElementViewModelDiscriminator(
                item.itemElement,
                ({ text, cssClass }) => (
                    <ListItem key={index} selected={item.isSelected} className={cssClass}>
                        {text}
                    </ListItem>
                ),
                ({ text, link: action }) => (
                    <StyledMenuItemAnchor key={index} selected={item.isSelected} action={action}>
                        {text}
                    </StyledMenuItemAnchor>
                ),
                () => null
            );
        })}
    </StyledDefaultMenuSection>
);

export default memo(ItemsRenderer);
